// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, LoadCart } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import { xGoogleAnalyticsState } from "@sc/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@sc/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { parseProductCategories } from "@sc/XDL/Utilities";

export const _GaRemoveCartLines: typeof LoadCart = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (state.xGoogleAnalytics.removeFromCartLineEvent) {
        const dataLayer = getDataLayer();
        const cart = getCurrentCartState(props.getState()).value;
        const cartLines = cart?.cartLines;
        const session = getSession(state);

        if (!dataLayer || !cartLines) {
            return;
        }

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.removeFromCartLineEventName,
            ecommerce: {
                currency: session.currency?.currencyCode,
                value: cart?.orderGrandTotal,
                affiliation: state.xGoogleAnalytics.affiliation,
                sales_rep: state.xGoogleAnalytics.salesRep || "",
                is_rep: state.xGoogleAnalytics.isRep || "",
                bill_to_num: state.xGoogleAnalytics.billToNum || "",
                ship_to_num: state.xGoogleAnalytics.shipToNum || "",
                cust_type: state.xGoogleAnalytics.customerType || "",
                login_type: state.xGoogleAnalytics.loginType || "",
                warehouse: state.xGoogleAnalytics.warehouse || "",
                items: [] as any,
            },
        };

        cartLines.forEach((cartLine, idx) => {
            googleAnalyticsData.ecommerce.items.push({
                item_name: cartLine.shortDescription,
                item_id: cartLine.erpNumber,
                price: cartLine.pricing?.unitNetPrice,
                quantity: cartLine.qtyOrdered,
                index: cartLine.line,
                discount: cartLine.pricing
                    ? cartLine.pricing.unitNetPrice < cartLine.pricing.unitListPrice
                        ? cartLine.pricing.unitListPrice - cartLine.pricing.unitNetPrice
                        : 0
                    : 0,
                item_brand: state.xGoogleAnalytics.includeProductBrand ? cartLine.brand?.name || "" : undefined,
                item_list_id: state.xGoogleAnalytics.includeProductCategory
                    ? cartLine.properties?.["categoriesIds"] || ""
                    : undefined,
                affiliation: state.xGoogleAnalytics.affiliation,
                ...parseProductCategories(
                    cartLine?.properties?.itemCategoriesShortDescription,
                    true,
                    state.xGoogleAnalytics.includeProductCategory,
                ),
            });
        });

        dataLayer.push({ ecommerce: null });
        dataLayer.push(googleAnalyticsData);
    }
};

addToEndOfChain(chain, _GaRemoveCartLines);
